import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React, { useState } from "react"

export interface IGatsbyImageSharp {
    childImageSharp: {
        gatsbyImageData: IGatsbyImageData;
    }
}

export type ImageRecord = Record<string, IGatsbyImageSharp>;

interface ImageProps {
    className?: string;
    childImageSharp: IGatsbyImageData;
    alt?: string;
    onLoadCallback?: () => any;
}

export const Image = ({ childImageSharp, alt = 'Logo Image', onLoadCallback }: ImageProps): JSX.Element => {
    return (
        <GatsbyImage
            image={childImageSharp}
            alt={alt}
        />
    );
};